module.exports = __webpack_public_path__ + "static/media/get-started-4.9fc19fbc.svg";